export const namespaces = {
  components: {
    infoMessageComponent: 'infoMessageComponent',
    greetingsComponent: {
      greetingsComponent: 'greetingsComponent',
    },
  },
  dataSource: {
    apiLocalidadesIBGE: 'apiLocalidadesIBGE',
    apiViacep: 'apiViacep',
    requests: 'requests',
  },
  layout: {
    footerComponent: {
      footerComponent: 'footerComponent',
    },
    headerComponent: {
      notificationsComponent: {
        notificationsComponent: 'notificationsComponent',
      },
      headerComponent: 'headerComponent',
      headerMenu: 'headerMenu',
    },
    sidebarComponent: {
      menuItems: 'menuItems',
      sidebarComponent: 'sidebarComponent',
    },
    layout: 'layout',
  },
  pages: {
    changePassword: {
      changePassword: 'changePassword',
    },
    deleteAccount: {
      deleteAccount: 'deleteAccount',
    },
    emailConfirmation: {
      emailConfirmation: 'emailConfirmation',
    },
    events: {
      listEvents: {
        listEvents: 'listEvents',
      },
      manageEvent: {
        manageEvent: 'manageEvent',
      },
    },
    examples: {
      exampleForm: {
        exampleForm: 'exampleForm',
      },
      examplePage: {
        examplePage: 'examplePage',
      },
    },
    fidelity: {
      credit: {
        credit: 'credit',
      },
      creditBalance: {
        creditBalance: 'creditBalance',
      },
      simulator: {
        simulator: 'simulator',
      },
    },
    financial: {
      accountsPayable: {
        details: {
          accountsPayableDetails: 'accountsPayableDetails',
        },
        listPayables: {
          listPayables: 'listPayables',
        },
      },
    },
    forgotpassword: {
      forgotPassword: 'forgotPassword',
    },
    home: {
      home: 'home',
    },
    initial: {
      initialPage: 'initialPage',
    },
    listUsers: {
      listUsers: 'listUsers',
    },
    login: {
      loginComponent: {
        loginComponent: 'loginComponent',
      },
      registerComponent: {
        registerComponent: 'registerComponent',
      },
      tokenUserValidationComponent: {
        tokenUserValidationComponent: 'tokenUserValidationComponent',
      },
    },
    notFound: {
      notFound: 'notFound',
    },
    notificationCategories: {
      listCategories: {
        listCategories: 'listCategories',
      },
      manageCategory: {
        manageCategory: 'manageCategory',
      },
    },
    notificationSettings: {
      notificationSettings: 'notificationSettings',
    },
    profileedit: {
      profileEdit: {
        profileEdit: 'profileEdit',
      },
      matriculationHandle: {
        matriculationHandle: 'matriculationHandle',
      },
    },
    resetPassword: {
      resetPassword: 'resetPassword',
    },
    roles: {
      listRoles: {
        listRoles: 'listRoles',
      },
      manageRole: {
        manageRole: 'manageRole',
      },
    },
    service: {
      editService: {
        editService: 'editService',
        editEstimate: {
          editEstimate: 'editEstimate',
        },
      },
      flowService: {
        flowService: 'flowService',
      },
      geofert: {
        classificacaoSoloAmbienteProducao: {
          details: {
            details: 'details',
          },
          detailsEdit: {
            detailsEdit: 'detailsEdit',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        coletaPorTalhoes: {
          details: {
            details: 'details',
          },
          detailsEdit: {
            detailsEdit: 'detailsEdit',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        grid: {
          details: {
            details: 'details',
          },
          detailsEdit: {
            detailsEdit: 'detailsEdit',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: '',
          },
        },
        zonaDeManejo: {
          condutividadeEletrica: {
            details: {
              details: 'details',
            },
            detailsEdit: {
              detailsEdit: 'detailsEdit',
            },
            summary: {
              summary: 'summary',
            },
          },
          flow: {
            flow: 'flow',
          },
          satelite: {
            details: {
              details: 'details',
            },
            detailsEdit: {
              detailsEdit: 'detailsEdit',
            },
            summary: {
              summary: 'summary',
            },
          },
          vant: {
            details: {
              details: 'details',
            },
            detailsEdit: {
              detailsEdit: 'detailsEdit',
            },
            summary: {
              summary: 'summary',
            },
          },
        },
      },
      listServices: {
        listServices: 'listServices',
      },
      posVendas: {
        assistenciaTecnica: {
          details: {
            details: 'details',
          },
          detailsFields: {
            detailsFields: 'detailsFields',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        locacaoPiloto: {
          details: {
            details: 'details',
          },
          detailsFields: {
            detailsFields: 'detailsFields',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        montagemEquipamento: {
          details: {
            details: 'details',
          },
          detailsFields: {
            detailsFields: 'detailsFields',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
      },
      results: {
        pdfVisualizer: {
          pdfVisualizer: 'pdfVisualizer',
        },
        results: 'results',
      },
      serviceComponents: {
        fieldComponents: {
          dataPlantio: {
            dataPlantio: 'dataPlantio',
          },
          estagioCorte: {
            estagioCorte: 'estagioCorte',
          },
          maturador: {
            maturador: 'maturador',
          },
          nomeProduto: {
            nomeProduto: 'nomeProduto',
          },
          prntCalcario: {
            prntCalcario: 'prntCalcario',
          },
          prntOxido: {
            prntOxido: 'prntOxido',
          },
          summaryField: {
            summaryField: 'summaryField',
          },
          tombamento: {
            tombamento: 'tombamento',
          },
          variedade: {
            variedade: 'variedade',
          },
          vdesejado: {
            vdesejado: 'vdesejado',
          },
        },
        fillDetails: {
          fillDetails: 'fillDetails',
        },
        fillGridDetails: {
          fillGridDetails: 'fillGridDetails',
        },
        geoMap: {
          geoMap: 'geoMap',
        },
        geoMapSummary: {
          geoMapSummary: 'geoMapSummary',
        },
        gridFields: {
          gridFields: 'gridFields',
        },
        newLand: {
          newLand: 'newLand',
          searchBox: 'searchBox',
        },
        newService: {
          newService: 'newService',
        },
        renderSubtypeDynamicField: {
          renderSubtypeDynamicField: 'renderSubtypeDynamicField',
        },
        selectedLands: {
          selectedLands: 'selectedLands',
        },
        selectPropertyData: {
          selectPropertyData: 'selectPropertyData',
        },
        serviceEstimate: {
          serviceEstimate: 'serviceEstimate',
        },
        serviceRequestFields: {
          serviceRequestFields: 'serviceRequestFields',
        },
        successSolicitation: {
          successSolicitation: 'successSolicitation',
        },
        summary: {
          summary: 'summary',
        },
        uploadFiles: {
          uploadFiles: 'uploadFiles',
        },
      },
      serviceDetail: {
        serviceDetail: 'serviceDetail',
        estimateDetail: {
          estimateComponents: {
            estimateDetailFields: 'estimateDetailFields',
          },
          serviceEstimateDetail: 'serviceEstimateDetail',
        },
      },
      serviceEstimates: {
        listServiceEstimates: {
          listServiceEstimates: 'listServiceEstimates',
        },
      },
      shapefile: {
        geoMapShapefiles: 'geoMapShapefiles',
        importShapefiles: 'importShapefiles',
        importShapefilesFirstStage: 'importShapefilesFirstStage',
        importShapefilesHeader: 'importShapefilesHeader',
        importShapefilesSecondStage: 'importShapefilesSecondStage',
        importShapefilesThirdStage: 'importShapefilesThirdStage',
      },
      vant: {
        levantamentoDeFalhas: {
          details: {
            details: 'details',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        mapeamentoDeErvasInvasoras: {
          details: {
            details: 'details',
          },
          detailsFields: {
            detailsFields: 'detailsFields',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        mapeamentoDeLinhas: {
          details: {
            details: 'details',
          },
          detailsFields: {
            detailsFields: 'detailsFields',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        ortomosaico: {
          details: {
            details: 'details',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        projetoDePlantio: {
          details: {
            details: 'details',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        sistematizacao: {
          details: {
            details: 'details',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
        zonaDeManejo: {
          details: {
            details: 'details',
          },
          flow: {
            flow: 'flow',
          },
          summary: {
            summary: 'summary',
          },
        },
      },
    },
    serviceStatus: {
      serviceStatus: 'serviceStatus',
      estimateStatus: {
        estimateStatus: 'estimateStatus',
      },
    },
    sharedcomponents: {
      acesseOSite: {
        acesseOSite: 'acesseOSite',
      },
      autocompleteGoogleMaps: {
        autocompleteGoogleMaps: 'autocompleteGoogleMaps',
      },
      background: {
        background: 'background',
      },
      breakpointTester: {
        breakpointTester: 'breakpointTester',
      },
      bulas: {
        bulas: 'bulas',
      },
      cotacao: {
        cotacao: 'cotacao',
      },
      customPagination: {
        customPagination: 'customPagination',
      },
      dynamicFields: {
        dynamicFields: 'dynamicFields',
      },
      greenMarkerIcon: {
        greenMarkerIcon: 'greenMarkerIcon',
      },
      matriculationForm: {
        matriculationForm: 'matriculationForm',
      },
      newPassword: {
        newPassword: 'newPassword',
      },
      rectangleTag: {
        rectangleTag: 'rectangleTag',
      },
      revistaCoopercitrus: {
        revistaCoopercitrus: 'revistaCoopercitrus',
      },
      serviceStatusComponent: {
        estimateStatusComponent: {
          estimateStatusComponent: 'estimateStatusComponent',
        },
        serviceStatusComponent: 'serviceStatusComponent',
      },
      talhao: {
        areaTalhao: 'areaTalhao',
      },
    },
    system: {
      branches: {
        branches: 'branches',
        manageBranches: 'manageBranches',
      },
      equipamentModel: {
        equipamentModel: 'equipamentModel',
      },
      notifications: {
        manageNotification: 'manageNotification',
        notifications: 'notifications',
      },
      pageLogs: {
        pageLogs: 'pageLogs',
      },
      parameters: {
        parameters: 'parameters',
      },
    },
    user: {
      associateProfile: {
        associateProfile: 'associateProfile',
      },
      manageUser: {
        manageUser: 'manageUser',
      },
    },
  },
  common: 'common',
  success: {
    user: 'user',
    matriculation: 'matriculation',
    role: 'role',
    service: 'service',
    land: 'land',
    notification: 'notification',
    system: 'system',
    file: 'file',
    log: 'log',
    voucher: 'voucher',
    banner: 'banner',
    budget: 'budget',
    equipamentmodel: 'equipamentmodel',
    event: 'event',
    branch: 'branch',
    bp: 'bp',
    notificationCategory: 'notificationCategory',
    wordpressapi: 'wordpressapi',
  },
  error: {
    user: 'user',
    matriculation: 'matriculation',
    role: 'role',
    general: 'general',
    service: 'service',
    land: 'land',
    notification: 'notification',
    system: 'system',
    file: 'file',
    log: 'log',
    voucher: 'voucher',
    banner: 'banner',
    importkmlkmz: 'importkmlkmz',
    budget: 'budget',
    equipamentmodel: 'equipamentmodel',
    event: 'event',
    branch: 'branch',
    bp: 'bp',
    sap: 'sap',
    notificationCategory: 'notificationCategory',
    wordpressapi: 'wordpressapi',
  },
};

export const languages = {
  pt: 'pt',
  en: 'en-US',
};
